import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import FAQSection from './components/FAQSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <CardsSection />
        <CommentsSection />
        <AboutSection />
        <ContactSection />
        <FeaturesSection />
        <MediaSection />
        <RankingSection />
        <UpdatesSection />
        <FAQSection />
        <CarouselSection />
        <TopicsSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}